import { mergeDeepRight } from "ramda";

export const makeStylesFromThemeAndCustomStyles = (
  makeDefaultStyles,
  customWidgetStyle
) => (theme) =>
  mergeDeepRight(makeDefaultStyles(theme), customWidgetStyle || {});
